<template>
  <div class="animated fadeIn">
    <b-card header-tag="header">
      <div slot="header">
        <i class="fa fa-money"></i> Pagamentos
        <!-- <b-link :to="`${actionUri}/new/`" class="btn mr-2 btn-sm btn-primary float-right">
          <i class="fa fa-plus"></i>
          Entrada
        </b-link> -->
      </div>
      <b-card-body>
        <div class="form-row justify-content-start">          
          <div class="col-sm-3">
            <div class="form-group">
              <label>Status</label>
              <select :class="{'custom-select': true}" v-model="moneyOutStatus.selected">
                <option
                  v-for="(s, index) in moneyOutStatus.data"
                  :key="index"
                  :value="s.id"
                >{{s.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-row justify-content-start">
          <div class="col-sm-2">
            <div class="form-group">
              <label>Início</label>
              <datepicker
                :language="languages.ptBR"
                :bootstrapStyling="true"
                placeholder="Início"
                :calendar-button="true"
                calendar-button-icon="fa fa-calendar"
                v-model="startDate"
              ></datepicker>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">  
              <label>Horario</label>
              <div>
                <vue-timepicker input-class="form-control" v-model="startHour" format="HH:mm:ss"></vue-timepicker>
              </div>          
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label>Término</label>
              <datepicker
                :language="languages.ptBR"
                :bootstrapStyling="true"
                placeholder="Termino"
                :calendar-button="true"
                calendar-button-icon="fa fa-calendar"
                v-model="endDate"
              ></datepicker>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">  
              <label>Horario</label>
              <div>
                <vue-timepicker input-class="form-control" v-model="endHour" format="HH:mm:ss"></vue-timepicker>
              </div>              
            </div>
          </div>
          <!-- <div class="col-md-3">
                  <div class="form-group">
                    <label>Data Pagamento</label>
                    <datepicker :clear-button="true" :language="languages.ptBR" :bootstrapStyling="true" placeholder="Data pagamento" :calendar-button="true" calendar-button-icon="fa fa-calendar" v-model="endedDate"></datepicker>
                  </div>
          </div>-->
        </div>
        <b-row>
          <b-col md="6" class="my-1">
            <b-form-group label-cols-sm="0" label class="mb-0">
              <b-input-group>
                <b-input-group-append>
                  <b-button @click="searchPayments" variant="primary">Buscar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <carousel :perPage="1">
      <slide class="p-2">
        <b-card>
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <div class="callout">
                <small class="text-muted">
                  Total
                  <br />Pagamentos
                </small>
                <h4 class="h4">{{totalPayments}}</h4>
              </div>
            </div>
          </div>
        </b-card>
      </slide>
      <slide class="p-2">
        <b-card>
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <div class="callout">
                <small class="text-muted">
                  Total
                  <br />Transferências
                </small>
                <h4 class="h4">{{totalTransfers}}</h4>
              </div>
            </div>
          </div>
        </b-card>
      </slide>
      <slide class="p-2">
        <b-card>
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <div class="callout">
                <small class="text-muted">
                  Total
                  <br />Boletos
                </small>
                <h4 class="h4">{{totalBillPayments}}</h4>
              </div>
            </div>
          </div>
        </b-card>
      </slide>
      <slide class="p-2">
        <b-card>
          <div class="row">
            <div class="col-md-3 col-sm-12">
              <div class="callout">
                <small class="text-muted">
                  Total
                  <br />Saques
                </small>
                <h4 class="h4">{{totalWithDrawals}}</h4>
              </div>
            </div>
          </div>
        </b-card>
      </slide>
    </carousel>
    <b-card>      
      <b-table
        :items="result.data"
        :fields="fields"
        :striped="true"
        thead-class="hidden_header"
        tdClass="btable-td"
        :bordered="false"
        :borderless="true"
      >
      <template #cell(row-details)="row">
        <table class="table-moneyouts-item" style="height:100% important!;border:solid 0px;background-color: none !important;" width="100%" cellpadding="0">
          <tr>
            <td style="width: 20%; font-weight: bold;">{{getMoneyOutType(row.item.type)}}</td>
            <td>{{formatDateTimeFields(row.item.scheduledDate)}}</td>            
            <td style="width: 31%;">
              {{bindStatusName(row.item.status)}}<br/>
              <strong>{{formatDecimalFields(row.item.amount)}}</strong></td>
          </tr>
        </table>
      </template>      
      </b-table>
      <nav>
        <b-pagination
          :total-rows="result.rowCount"
          :per-page.sync="result.pageSize"
          v-model="currentPage"
          prev-text="‹"
          next-text="›"
          @change="pageIndexChanged"
          first-text="«"
          last-text="»"
          align="center"
        />
    </nav>
    </b-card>
  </div>
</template>
<style>
  .vue__time-picker input.display-time {
    height: 35px !important;
  }
  .hidden_header {
    display: none;
  }
  .table-moneyouts-item{
    font-size: 11px;
    width: 100%;
  }
  .table-moneyouts-item td{
    padding: 0.25rem !important;
    text-align: left;
    vertical-align: middle !important;
  }

  .table-moneyouts-item td:last-child{
    text-align: right !important;
  }

  .table-moneyouts-item tr {
    background: none !important;
  }
  .table-moneyouts-item tr:nth-of-type(odd) {
    background: none !important;
  }
  .VueCarousel-dot-container, .VueCarousel-dot {
    margin-top: 0px !important;
  }
</style>
<script>
import cTable from "../../../components/base/Table.vue";
import domainService from "../../../services/MoneyFlow/moneyOutService";
import moneyOutGroupService from "../../../services/MoneyFlow/moneyOutGroupService";
import sellerService from "../../../services/Customer/sellerService";
import salesPersonService from "../../../services/Customer/salesPersonService";
import helperService from "../../../services/Helper/helperService";
import listPage from "../../../mixins/listPage";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { ModelListSelect } from "vue-search-select";
import { getDateDayBefore } from "../../../shared/utils";
import moment from 'moment';
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { Carousel, Slide } from 'vue-carousel';
export default {
  components: {
    cTable,
    Datepicker,
    ModelListSelect,
    VueTimepicker,
    Carousel,
    Slide
  },
  mixins: [listPage],
  data() {
    return {
      exportErrorModal: false,
      exportErrorMessage: '',
      showExportSelectorModal: false,
      exportButtonModalDisabled: false,
      selectedExportType: 341,
      exportTypeList: [
        { id: 341, name: "Itaú", },
        { id: 237, name: "Bradesco", }
      ],            
      languages: lang,
      actionUri: "/partners/payments",
      startDate: getDateDayBefore(new Date(), 7),
      startHour: '00:00:00',
      endDate: new Date(),
      endHour: '23:59:59',
      endedDate: null,
      scheduleDate: null,
      bankCode: null,
      bankList: [],
      summary: {
        total: 0,
        totalBillPayments: 0,
        totalTransfers: 0,
        totalWithDrawals: 0,
      },
      fields: [
        { key: 'row-details', label: 'detalhes', sortable: false }            
      ],  
      customActions: [
        {
          cssClass: "btn mr-2 btn-md btn-info action-btn",
          html: '<i class="fa fa-edit"></i>',
          action: "view",
        },
      ],
      sellers: {
        selected: null,
        data: [],
        query: "",
      },
      salesPeople: {
        selected: null,
        data: [],
        query: "",
      },      
      moneyOutStatus: {
        selected: '',
        data: [],
      },
      moneyOutGroup: {
        selected: '',
        data: [],
      },
      currentPage: 1,
      selectedItems: [],
      selectAll: false
    };
  },
  computed: {
    isMoneyOutGroupButtonEnabled: function() {
      return false;
    },
    isMoneyOutGroupBanksEnabled: function() {     
      return false;
    },
    totalPayments(){
      return this.summary.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalTransfers(){
      return this.summary.totalTransfers.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalBillPayments(){
      return this.summary.totalBillPayments.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    totalWithDrawals(){
      return this.summary.totalWithDrawals.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  },
  created() {
    this.moneyOutStatus.data = domainService.getStatuses()
    this.moneyOutStatus.data.unshift({id: '', name:'Selecione:'}) 

    this.fetchSummaryData();
  },
  methods: {
    createMoneyOutGroup() {
      if(this.selectedItems.length == 0) {
        return;
      }
      this.showExportSelectorModal = true;
    },  
    selectedItemsChanged(item) {
      if(item == null) {
        this.selectAll = false;
      }
    },
    selectAllItems(checked) {      
    	if(checked) {
        for (let index = 0; index < this.result.data.length; index++) {
          const element = this.result.data[index];
          if(element.status != 'PENDING') continue;
          const el = this.selectedItems.find(function(item) { return item.id == element.id });
          if(el == null) {
            this.selectedItems.push(element);
          }
        }
      }
      else {
        for (let index = 0; index < this.result.data.length; index++) {
          const element = this.result.data[index];
          let itemIdx = this.selectedItems.indexOf(element);
          this.selectedItems.splice(itemIdx, 1);
        }
      }
      this.selectAll = checked;
    },  
    getSearchRequest() {
      return {
        sellerId: this.$store.getters.currentUser.id,
        salesPersonId: '',
        bankCode: '',
        type: '',
        status: this.moneyOutStatus.selected,
        scheduledDate: this.scheduleDate == null ? '' : this.scheduleDate,
        endedDate: this.endedDate == null ? '' : this.endedDate,
        keywords: this.keywords,
        startDate: this.startDate == null ? '' : this.formatDate(this.startDate, this.startHour),
        endDate: this.endDate == null ? '' : this.formatDate(this.endDate, this.endHour),
        moneyOutGroupId: this.moneyOutGroup.selected
      }
    },
    formatDate(date, hour) {
      let d = moment(date).format('YYYY-MM-DD');
      let f = moment(`${d} ${hour}`).toDate();
      return f;
    },
    pageIndexChanged(page) {
      this.currentPage = page;
      this.fetchData(page);
    },
    searchPayments() {
      this.fetchData(1)
      this.fetchSummaryData()
      return false
    },
    fetchSummaryData() {
      const self = this;
      self.showLoading();
      domainService
        .summary(this.getSearchRequest())
        .then(
          (response) => {
            self.summary = response.data;
            self.hideLoading();
          },
          (error) => {
            self.hideLoading();
          }
        );
    },
    fetchData(page) {
      const self = this;
      self.showLoading();
      domainService
        .findAll(
          this.getSearchRequest()
          ,
          page
        )
        .then(
          (response) => {
            if (response.status == 204) {
              self.$data.result = self.getEmptyResult();              
            } else {
              self.$data.result = response.data;              
            }
            self.selectAll = false;
            self.hideLoading();
          },
          (error) => {
            self.selectAll = false;
            self.hideLoading();
          }
        );
    },
    exportToExcel() {
      const self = this;
      this.showLoading();
      domainService.findAllExport(this.getSearchRequest()).then(
        (response) => {
          window.open(response);
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );      
    },
    searchSellers(newQuery) {
      if (newQuery.length < 2) return;
      const self = this;
      this.showLoading();
      sellerService.all(newQuery).then(
        (response) => {
          self.sellers.data = response.status == 204 ? [] : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    searchSalesPeople(q) {
      if (q == null || q.length < 2) return;
      const self = this;
      this.showLoading();
      salesPersonService.all(q, '').then(
        (response) => {
          self.salesPeople.data = response.status == 204 ? [] : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      );
    },
    searchMoneyOutGroup(q) {
      if (q == null || q.length < 2) return;
      const self = this;
      this.showLoading();
      moneyOutGroupService.all(q).then(
        (response) => {
          self.moneyOutGroup.data = response.status == 204 ? [] : response.data;
          self.hideLoading();
        },
        () => {
          self.hideLoading();
        }
      )
    },
    searchBanks() {
      const self = this
      this.showLoading()
      helperService.banksGetList().then(
        (response) => {
          self.bankList = response.status == 204 ? [] : response.data
          self.bankList.unshift({ COMPE: null, LongName: 'Selecione um banco'})
          self.hideLoading()
        },
        () => {
          self.hideLoading()
        }
      );
    },
    onCustomActionClick(action, row) {
      this.$router.push({
        path: this.actionUri.concat(`/view/${row.item.type.toLowerCase()}/${row.item.id}`),
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.exportErrorModal = false;
      this.exportErrorMessage = '';
      this.handleSubmit();
    },
    handleSubmit() {
      const self = this;
      this.exportButtonModalDisabled = true;
      moneyOutGroupService.create({
        name: 'Remessa',
        bankCode: this.isMoneyOutGroupBanksEnabled ? new String(this.selectedExportType) : "",
        moneyOuts: this.selectedItems.map(function(el) { return el.id })
      }).then(
        response => {
          self.selectedItems = [];
          self.selectAll =  false;
          self.fetchData(1);
          // Hide the modal manually
          self.$nextTick(() => {
            self.$refs.modal.hide();
            this.exportButtonModalDisabled = false;
          });
        },
        error => {
          self.exportErrorMessage =
            "Ocorreu um erro ao criar a remessa.";
          self.exportErrorModal = true;
          this.exportButtonModalDisabled = false;
        }
      );
    },
    formatDateTimeFields(value) {
      return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
    },
    getMoneyOutType(value) {
      switch (value) {
          default:
          case "WITHDRAW":
            return "Saque";
          case "BILLPAYMENT":
            return "Boleto";
          case "BANKTRANSFER":
            return "Transferência";
            case "PIXTRANSFER":
            return "Pix";
      }
    },
    formatDecimalFields(value) {
      return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    bindBusinessTypeName(value) {
      switch(value.toUpperCase())
      {
        case 'SELLER':
          return 'Empresa';
        case 'SALESPERSON':
          return 'Representante';
        case 'Partner':
            'Administrador';
      }
    },
    bindStatusName(value) {
      switch(value.toUpperCase()) {
        case 'CREATED':
          return 'Criado';
        case 'PROCESSING':
          return 'Processando';
        case 'CANCELED':
          return 'Cancelado';
        case 'PENDING':
          return 'Pendente';
        case 'ANALYSIS':
          return 'Em análise';
        case 'DONE':
          return 'Finalizado';
      }
    }
  },
};
</script>
